var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFireflyLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 363,
    height: 97,
    viewBox: "0 0 363 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "firefly_logo_svg__firefly_logo_svg__Group_28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "firefly_logo_svg__firefly_logo_svg__Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "firefly_logo_svg__firefly_logo_svg__Fill_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.453 2.16586C133.273 3.61213 131.752 5.49894 130.888 7.82511C130.253 9.55102 129.941 12.194 129.941 15.7501V21.3825H122V28.3613H129.941V74.3248H138.875V28.3613H149.206V21.3825H138.875V16.4962C138.875 13.3073 139.437 11.1317 140.573 9.96828C141.705 8.8049 143.633 8.22056 146.364 8.22056C148.024 8.22056 149.791 8.38764 151.652 8.72151L153.001 0.896403C149.941 0.29556 147.144 0 144.614 0C140.686 0 137.637 0.718714 135.453 2.16586Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "firefly_logo_svg__firefly_logo_svg__Fill_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157 74.5712H166.118V22H157V74.5712Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "firefly_logo_svg__firefly_logo_svg__Fill_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157 12.8768H166.118V2H157V12.8768Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "firefly_logo_svg__firefly_logo_svg__Fill_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.984 21.806C192.212 23.008 190.281 25.4954 188.192 29.2639V21.2024H180V74.384H189.101V46.5437C189.101 42.7371 189.609 39.232 190.619 36.0286C191.292 33.921 192.421 32.277 194.008 31.0924C195.594 29.9068 197.378 29.3142 199.365 29.3142C201.596 29.3142 203.821 29.9681 206.044 31.2709L209.177 22.9077C206.01 20.9677 202.895 20 199.823 20C197.7 20 195.751 20.6036 193.984 21.806Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "firefly_logo_svg__firefly_logo_svg__Fill_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221 41.9426C221.299 37.4028 222.87 33.7767 225.701 31.0634C228.536 28.3559 232.029 27 236.189 27C240.783 27 244.521 28.6956 247.402 32.0918C249.284 34.2852 250.423 37.5667 250.821 41.9426H221ZM235.947 20C228.57 20 222.567 22.4182 217.942 27.2531C213.314 32.0883 211 38.8812 211 47.6326C211 56.0934 213.292 62.6682 217.868 67.3499C222.444 72.0374 228.637 74.384 236.452 74.384C242.651 74.384 247.75 72.9117 251.742 69.9745C255.728 67.0336 258.462 62.9036 259.94 57.5755L250.585 56.4487C249.21 60.173 247.346 62.8862 244.999 64.5827C242.651 66.2827 239.822 67.1318 236.498 67.1318C232.039 67.1318 228.316 65.6169 225.335 62.5755C222.35 59.5402 220.691 55.1632 220.354 49.4473H260.187C260.221 48.3975 260.237 47.6164 260.237 47.0963C260.237 38.5041 257.975 31.8424 253.448 27.1057C248.923 22.3689 243.089 20 235.947 20Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "firefly_logo_svg__firefly_logo_svg__Fill_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.453 2.16586C273.274 3.61213 271.752 5.49894 270.889 7.82511C270.254 9.55102 269.936 12.194 269.936 15.7501V21.3825H262V28.3613H269.936V74.3248H278.874V28.3613H289.206V21.3825H278.874V16.4962C278.874 13.3073 279.438 11.1317 280.569 9.96828C281.699 8.8049 283.634 8.22056 286.359 8.22056C288.024 8.22056 289.786 8.38764 291.652 8.72151L293.001 0.896403C289.935 0.29556 287.144 0 284.615 0C280.687 0 277.631 0.718714 275.453 2.16586Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "firefly_logo_svg__firefly_logo_svg__Fill_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M295 74.512H304.118V2H295V74.512Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "firefly_logo_svg__firefly_logo_svg__Fill_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M353.129 22L341.644 52.8178C340.191 56.7299 338.943 60.7497 337.898 64.8617C336.75 60.5829 335.452 56.5022 334 52.6177L322.819 22H313L333.395 74.9724C333.023 75.9332 332.752 76.6607 332.582 77.1607C331.305 80.712 330.374 82.9355 329.802 83.8298C329.022 85.0261 328.028 85.9536 326.813 86.6205C325.6 87.2811 323.983 87.6145 321.956 87.6145C320.475 87.6145 318.734 87.3476 316.745 86.8203L317.758 95.2289C319.915 95.9623 321.87 96.3248 323.626 96.3248C326.53 96.3248 329.022 95.6406 331.119 94.2622C333.208 92.8836 335.062 90.7168 336.683 87.7655C337.898 85.5752 339.605 81.5748 341.795 75.7667L362.237 22H353.129Z",
    fill: "#4A4A4A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "firefly_logo_svg__firefly_logo_svg__Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "firefly_logo_svg__firefly_logo_svg__Shape"
  }, /*#__PURE__*/React.createElement("g", {
    id: "firefly_logo_svg__firefly_logo_svg__path0_fill-link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "firefly_logo_svg__firefly_logo_svg__path0_fill",
    d: "M47.9466 20.4693C44.4086 21.1773 40.7798 21.2615 37.2144 20.7183C30.0505 19.3904 24.4698 13.0277 17.0108 13C9.57861 13.9682 4.56124 20.497 0 26.0021C4.34661 23.7337 8.80053 19.5564 14.0594 21.4375C19.5865 23.9273 23.6112 30.2071 30.1579 29.9028C36.7047 29.5985 42.4196 24.5636 47.9466 20.4693Z",
    fill: "url(#firefly_logo_svg__firefly_logo_svg__paint0_linear)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "firefly_logo_svg__firefly_logo_svg__Shape_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "firefly_logo_svg__firefly_logo_svg__path1_fill-link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "firefly_logo_svg__firefly_logo_svg__path1_fill",
    d: "M91.4289 24.7902C91.4289 18.7041 98.3243 17.5975 102.778 16.491C94.7291 12.2584 85.8481 8.05342 76.4571 9.18764C64.3565 10.2665 54.7242 18.5934 45.1187 25.4265C39.7526 29.0781 33.8498 33.1447 27.1152 32.5361C23.0638 32.0658 20.166 28.8015 17 26.533C18.6367 33.4214 21.6686 41.3058 29.0471 43.2976C46.058 47.0322 61.244 34.9983 78.0133 34.5003C79.6626 34.1782 81.3408 34.8896 82.2931 36.3147C83.2457 37.7398 83.2928 39.6101 82.4137 41.0844C76.8327 50.6286 64.9736 53.1735 54.912 52.8969C60.8147 59.232 67.925 65.3733 76.806 66.1205C86.8139 66.8674 96.151 62.1645 105.301 58.6789C98.0024 58.6789 89.8994 57.9319 84.8283 51.7904C92.0948 51.1104 99.241 49.436 106.078 46.8109C100.256 40.3927 91.6971 34.4173 91.4289 24.7902Z",
    fill: "#FF9F00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "firefly_logo_svg__firefly_logo_svg__Shape_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "firefly_logo_svg__firefly_logo_svg__path2_fill-link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "firefly_logo_svg__firefly_logo_svg__path2_fill",
    d: "M51.0862 56.3131C45.72 54.9023 40.9441 58.5263 37 61.8459C39.6887 61.182 42.4456 60.8569 45.2102 60.8777C52.5887 62.4545 55.5133 71.4454 62.8381 73.1606C68.4189 74.3778 73.5706 70.7815 78.2123 68.347C75.3161 68.3176 72.4302 67.9839 69.5995 67.3511C62.7576 64.7784 58.1159 58.3603 51.0862 56.3131Z",
    fill: "url(#firefly_logo_svg__firefly_logo_svg__paint1_linear)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "firefly_logo_svg__firefly_logo_svg__paint0_linear",
    x1: 341.959,
    y1: -38.5016,
    x2: 1.34114,
    y2: -38.5016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#3EA045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#64A73D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#88AF35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A8B52E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C4BA29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#DABF24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#EBC220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F6C41E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FDC61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FFC61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FFC41B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFBD1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FFB216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FFA112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FF8B0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FF7004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "firefly_logo_svg__firefly_logo_svg__paint1_linear",
    x1: 330.928,
    y1: 3.00162,
    x2: 38.1545,
    y2: 3.00162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#3EA045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#64A73D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#88AF35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A8B52E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C4BA29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#DABF24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#EBC220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F6C41E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FDC61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FFC61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FFC41B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFBD1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FFB216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FFA112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FF8B0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FF7004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6000"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireflyLogo);
export default __webpack_public_path__ + "static/media/firefly_logo.30460ee5ecaa4d504febb26e67d0b33b.svg";
export { ForwardRef as ReactComponent };